// NewsDAO.js
import WebSocketManager from './WebSocketManager';

class PullDAO {
    constructor() {
        // Get the singleton instance of WebSocketManager
        this.wsManager = WebSocketManager.getInstance();
    }

    /**
     * Lists news by sending a request through the WebSocket connection.
     *
     * @param {number} row - Number of rows per page (default is 10).
     * @param {number} page - Page number to retrieve (default is 1).
     * @returns {Promise<Object>} - The response from the WebSocket server containing the list of news articles.
     * @throws {Error} - Throws an error if the WebSocket is not authenticated or not open.
     */
    async addRentalCancel(payload) {
        try {
            console.log('addRentalCancel payload:', payload);
    
            // 通过 wsManager.request 发送请求
            const response = await this.wsManager.request(
                'rental_cancel_form', // entity
                'add_rental_cancel', // action
                payload // 接收的表单数据
            );
    
            console.log('addRentalCancel response:', response);
    
            // 返回响应结果
            return response;
        } catch (error) {
            console.error('Error in addRentalCancel:', error);
            throw error; // 抛出错误供调用者捕获
        }
    }
    
    
    async listNews(row = 10, page = 1) {
        try {
            console.log('listNews:', row, page);
            // Ensure the WebSocket is connected and authenticated
            // const isConnected = await this.wsManager.connect();
            // if (!isConnected) {
            //     throw new Error('Unable to establish WebSocket connection.');
            // }

            // console.log('newsDAO connected');

            // Construct the message payload
            // const message = JSON.stringify({
            //     entity: 'news',
            //     action: 'list_news',
            //     payload: {
            //         row: row,
            //         page: page
            //     }
            // });

            // Send the request and wait for the response
            // const response = await this.wsManager.request(message);
            const response = await this.wsManager.request('news', 'list_news', { row, page });

            console.log('listNews response:', response);

            // Optionally, you can add additional processing of the response here
            return response;
        } catch (error) {
            console.error('Error in listNews:', error);
            throw error;
        }
    }


    
    /**
     * Lists offers by sending a request through the WebSocket connection.
     *
     * @param {number} row - Number of rows per page (default is 10).
     * @param {number} page - Page number to retrieve (default is 1).
     * @returns {Promise<Object>} - The response from the WebSocket server containing the list of offers.
     * @throws {Error} - Throws an error if the WebSocket is not authenticated or not open.
     */
    async listOffers(row = 10, page = 1) {
        try {

            const payload = {
                row: row,
                page: page
            }

            // Send the request and wait for the response
            const response = await this.wsManager.request('offer','list_offers',payload);

            console.log('listOffers response:', response);

            // Optionally, you can add additional processing of the response here
            return response;
        } catch (error) {
            console.error('Error in listOffers:', error);
            throw error;
        }
    }

    async listParkings(params) {
        try {

            const payload = {
                row: params.row,
                page: params.page,
                county: params.county,
                district: params.district,
                parking_type: params.parking_type,
            }

            // alert('listParkings payload:', payload);
            console.log('listParkings payload:', payload);

            // Send the request and wait for the response
            const response = await this.wsManager.request('parking','list_parkings',payload);

            console.log('listParkings response:', response);

            // Optionally, you can add additional processing of the response here
            return response;
        } catch (error) {
            console.error('Error in listParkings:', error);
            throw error;
        }
    }

    // New method to fetch all parkings
    async fetchAllParkings() {
        try {
            const payload = {
                row: 10000,
                page: 1,
                county: '',
                district: '',
                parking_type: ''
            };
            const response = await this.wsManager.request('parking','list_parkings',payload);

            if (!response.success) {
                throw new Error('Failed to fetch all parkings');
            }

            return response.parkings;
        } catch (error) {
            console.error('Error in fetchAllParkings:', error);
            throw error;
        }
    }

    async listLottories(row = 10, page = 1) {
        try {

            const payload = {
                row: row,
                page: page
            }

            // Send the request and wait for the response
            const response = await this.wsManager.request('lottery','list_lottories',payload);

            console.log('listLottories response:', response);

            // Optionally, you can add additional processing of the response here
            return response;
        } catch (error) {
            console.error('Error in listLottories:', error);
            throw error;
        }
    }

    async listRecruits(row = 10000, page = 1) {
        try {

            const payload = {
                row: row,
                page: page
            }

            // Send the request and wait for the response
            const response = await this.wsManager.request('recruit','list_recruits',payload);

            console.log('listRecruits response:', response);

            // Optionally, you can add additional processing of the response here
            return response;
        } catch (error) {
            console.error('Error in listRecruits:', error);
            throw error;
        }
    }
    async addRentalApply(payload) {
        try {
            console.log('addRentalApply payload:', payload);
    
            // 调用 WebSocketManager 的 request 方法
            const response = await this.wsManager.request(
                'rental_apply_form', // 实体名称，表示处理的业务对象
                'add_rental_apply',  // 动作名称，表示具体操作
                payload              // 传递的表单数据
            );
    
            console.log('addRentalApply response:', response);
            return response; // 返回后台的响应
        } catch (error) {
            console.error('Error in addRentalApply:', error);
            throw error; // 抛出错误供调用方处理
        }
    }
   
    async addCollaboration(payload) {
        try {
            console.log('addCollaboration payload:', payload);
            const response = await this.wsManager.request(
                'collaboration_form', // entity
                'add_collaboration', // action
                payload
            );
            return response;
        } catch (error) {
            console.error('Error in addCollaboration:', error);
            throw error;
        }
    }
}
    export default PullDAO;
